import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../common/Form";
import Fieldset from "../common/Fieldset";
import Files from "../common/Files";
import { FileComponentNames } from "../../constants/ComponentConstants";
import { getPropertyFilesComponentProps } from "../../components/common/FilesHelperUtil";
import TextInput from "../../components/common/TextInput";
import TextAreaInput from "../../components/common/TextAreaInput";
import DateInput from "../../components/common/DateInput";
import SelectInput from "../../components/common/SelectInput";
import NumberInput from "../../components/common/NumberInput";
import AutoComplete from "../../components/common/AutoComplete";
import Datalist from "../../components/common/Datalist";
import Revert from "../../components/common/Revert";
import CheckBoxWithChild from "../../components/common/CheckBoxWithChild";
import Row from "../../components/common/Row";
import Section from "../../components/common/Section";

const DemoForm = (props) => {
    const {
        model,
        originalModel,
        fileDownloadUrl,
        onChange,
        onSave,
        onClose,
        onDropFiles,
        onRemoveFile,
        errors,
        revertAll,
        hasUnsavedChanges
    } = props;

    const demoFilesMimeTypes = 'application/vnd.ms-excel,application/msexcel, application/x-excel, application/x-msexcel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/png, image/jpeg, image/jpeg, image/gif, image/tiff';
    const demoFilesExtensions = 'pdf, xls, xlsx, doc, docx, ppt, pptx, jpeg, jpg, gif, png, tiff';
    const demoFilesProps = getPropertyFilesComponentProps("Demo Files", FileComponentNames.DEMO, fileDownloadUrl, model.filesComponent, originalModel.filesComponent, false, onDropFiles, onRemoveFile, onChange, {
        mimeTypes: demoFilesMimeTypes,
        extensions: demoFilesExtensions
    });

    return (
        <Fragment>
            <Section>
                <Form name="demo"
                    title={"Demo"}
                    headerVisible
                    isNotRequired
                    leftButtonLabel={model.datumIndiening ? null : "Bewaren"}
                    onLeftButtonClick={onSave}
                    rightButtonLabel="Sluiten"
                    onRightButtonClick={onClose}>
                    <TextInput
                        name="textInput"
                        label="Een TextInput"
                        size={6}
                        value={model.textInput}
                        originalValue={originalModel.textInput}
                        onChange={onChange}
                    />
                    <TextAreaInput
                        name="textArea"
                        label="Een TextArea"
                        size={6}
                        value={model.textArea}
                        originalValue={originalModel.textArea}
                        onChange={onChange}
                        height={6}
                    />
                    <DateInput
                        name="datumInput"
                        label="Een DatumInput"
                        size={6}
                        value={model.datumInput}
                        originalValue={originalModel.datumInput}
                        onChange={onChange} />
                    <SelectInput
                        items={[
                            { label: "andere", value: "ANDERE" },
                            { label: "abc", value: "ABC" },
                            { label: "def", value: "DEF" },
                            { label: "ghi", value: "GHI" },
                            { label: "jkl", value: "JKL" }]}
                        size={6}
                        name="selectInput"
                        label="Een SelectInput"
                        value={model.selectInput}
                        originalValue={originalModel.selectInput}
                        onChange={onChange}
                    />
                    <AutoComplete
                        items={[
                            { label: "andere", value: "ANDERE" },
                            { label: "abc", value: "ABC" },
                            { label: "def", value: "DEF" },
                            { label: "ghi", value: "GHI" },
                            { label: "jkl", value: "JKL" }]}
                        size={6}
                        name="autoComplete"
                        label="Een AutoComplete"
                        value={model.autoComplete}
                        originalValue={originalModel.autoComplete}
                        onChange={onChange}
                    />
                    <NumberInput
                        label="Een NumberInput"
                        name="numberInput"
                        size={6}
                        onChange={onChange}
                        value={model.numberInput}
                        originalValue={originalModel.numberInput}
                    />
                    <CheckBoxWithChild
                        name="checkboxWithChild"
                        label="Een CheckboxWithChild"
                        size={6}
                        value={model.checkboxWithChild}
                        onChange={onChange}
                    />
                    <Row noSpacing>
                        <div className="l-grid__col:4/12">
                            <h6>Demo - {model.title}</h6>
                            <p>Welcome to the demo. This is a demo text. Look around. Welcome to the demo. This is a demo text. Look around. Welcome to the demo. This is a demo text. Look around.</p><br />
                        </div>
                        <div className="l-grid__col:6/12">
                            <Files {...demoFilesProps} />
                        </div>
                    </Row>
                </Form>
            </Section>
            <Section>
                <Fieldset title="An Extra Fieldset Below The Form">
                    The fieldset is placed inside the Fragment, no extra div around the Form and Fieldset
                </Fieldset>
                {!hasUnsavedChanges ||
                    <Fieldset title="Revert All">
                        <Revert
                            onChange={revertAll}
                            standAlone
                            showWarning
                        />
                    </Fieldset>}

            </Section>
        </Fragment>);
};

DemoForm.propTypes = {
    model: PropTypes.object,
    originalModel: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    errors: PropTypes.object,
    onDropFiles: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    fileDownloadUrl: PropTypes.string.isRequired,
    templateDownloadUrl: PropTypes.string.isRequired,
    fileComponents: PropTypes.object,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    revertAll: PropTypes.func,
    hasUnsavedChanges: PropTypes.bool
};

export default DemoForm;